export class RecuperatorLocation {
  static DEFAULT = 1;
  static INDIVIDUAL = 2;
  static AGGREGATED = 3;
}
